"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const v4_1 = require("zod/v4");
exports.UIConfigSchema = v4_1.z.object({
    artifactSlug: v4_1.z.string().describe('Artifact slug'),
    description: v4_1.z.string().describe('Description'),
});
exports.nodeType = 'file_generatedReceivableResponseTape';
exports.IntermediateRecordConfigSchema = v4_1.z.object({
    operationDescription: v4_1.z
        .string()
        .describe('this will show up in operation node.'),
    tapeDescription: v4_1.z.string().describe('this will show up in tape node.'),
    useReceivableWaivers: v4_1.z.boolean().optional(),
});
exports.artifactType = 'receivableResponseTape';
//# sourceMappingURL=types.js.map